import React from 'react';
import { formattedNumber, dollarFormat } from './String';
import { renderDate } from './Date';

export const renderStartDate = (cell) => (cell.row.values.frequency === 'One-Off' ? renderDate(cell.row.values.date_end) : renderDate(cell.value));

export const renderMonth = (date) => {
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  if (date) {
    const d = new Date(date * 1000);
    return months[parseInt(d.getMonth(), 10)];
  }
  return '';
};

export const renderDollars = (number, alignment = 'right') => <div style={{ textAlign: alignment }}>{number ? dollarFormat(number) : ''}</div>;

export const renderNumber = (number, alignment = 'right') =>
  number !== undefined ? <div style={{ textAlign: alignment }}>{number !== 0 ? formattedNumber(number, '&nbsp;', 0) : 0}</div> : null;

export const renderName = (cell) => `${cell.value || cell.row.original.fullname ? cell.row.original.fullname : ''}`;
